var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"text--disabled text-right mb-0"},[_vm._v("\n    "+_vm._s(_vm.$t('components.version.createdUpdated', {
        created: _vm.humanizeDate(_vm.object.history.created_at),
        updated: _vm.humanizeDate(_vm.object.history.updated_at)
      }))+".\n    "),(_vm.withVersion)?_c('contributions-label',{attrs:{"version-type":_vm.objectType,"version-id":_vm.object.id,"versions-count":_vm.object.versions_count,"translate-key":"components.version.version"}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }